import { render, staticRenderFns } from "./UnsubscribeResultComponent.vue?vue&type=template&id=a762ad0c&scoped=true"
import script from "./UnsubscribeResultComponent.vue?vue&type=script&lang=js"
export * from "./UnsubscribeResultComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a762ad0c",
  null
  
)

export default component.exports